<script setup lang="ts">
import { type SideMenuItem } from "~/composables/useChromeMenuItems";

const { indentationLevel = 0, item } = defineProps<{ item: SideMenuItem; indentationLevel?: number }>();

const warnings = computed(() => useMenuStore().warnings);
const numWarnings = computed(() => warnings.value.find((w) => w.menuItem == item.type)?.count || 0);
</script>

<template>
  <NuxtLink :to="item.route" :class="[$style.navigationControlsItem, item.active.value && $style.active]">
    <CompositionSpacer v-for="n in Array.from({ length: indentationLevel }, (_, i) => i + 1)" :key="n" direction="horizontal" size="small" />

    <KeyValuePair direction="horizontal">
      <template #containerStart>
        <Icon v-if="item.iconId" :id="item.iconId" size="medium" :color="item.active.value ? '--color-white' : '--color-accent-300'" />
      </template>

      <template #containerEnd>
        <SideMenuLabel :item="item" />
      </template>
    </KeyValuePair>

    <div style="flex: 1" />

    <Label v-if="numWarnings > 0" colorBackground="--color-red-100" colorForeground="--color-red-200">
      <template #copy>
        <Copy type="body" size="small" color="--color-red-300"> {{ numWarnings }} </Copy>
      </template>
    </Label>
  </NuxtLink>
</template>

<style module>
.navigationControlsItem {
  position: relative;
  width: 100%;
  display: flex;
  padding: 0.5rem 1rem;
  cursor: pointer;
  overflow: visible;
  border: none !important;
  text-decoration: none !important;
  transition: background-color var(--transition-duration-medium) ease;

  &:hover {
    background-color: var(--color-accent-1000);
  }
}

.active {
  background-color: var(--color-accent-1000);
}

</style>
